import { useUser } from 'hooks'
import { useCallback, useEffect, useState } from 'react'
import { singularSdk, SingularConfig } from 'singular-sdk'
import { resetBlockedFirstSingularRequest } from './monkeypatchXHR'

const configParams = {
  sdkKey: process.env.REACT_APP_SINGULAR_SDK_KEY || '',
  sdkSecret: process.env.REACT_APP_SINGULAR_SDK_SECRET || '',
  productId: process.env.REACT_APP_SINGULAR_PRODUCT_ID || '',
}

export const useSingular = () => {
  const { loading } = useUser()
  const [initialized, setInitialized] = useState(false)

  const initSingular = useCallback(() => {
    if (initialized) return
    // We block the first page visit from Singular SDK, because we need to check the consent settings first.
    // We trigger our own page visit after consent is given (in usePageTracking)
    resetBlockedFirstSingularRequest()
    if (!window.isPrerender) {
      singularSdk.init(
        new SingularConfig(
          configParams.sdkKey,
          configParams.sdkSecret,
          configParams.productId
        )
      )
    }

    setInitialized(true)
  }, [initialized, setInitialized])

  useEffect(() => {
    if (loading) return
    initSingular()
  }, [initSingular, loading])

  return { initialized }
}
